/**
 * Set the local storage item function
 * @param {any} key key
 * @param {any} value value
 */
export const setLocalStorageItem = (key: string, value: any): void => {
  localStorage.setItem(key, JSON.stringify(value));
};

/**
 * Get the local storage item function
 * @param {any} key key
 * @returns {any} item
 */
export const getLocalStorageItem = (key: string): any | null => {
  const item = localStorage.getItem(key);
  return item ? JSON.parse(item) : null;
};

/**
 * Remove the local storage item function
 * @param {any} key key
 */
export const removeLocalStorageItem = (key: string): void => {
  localStorage.removeItem(key);
};
